export default "__VITE_ASSET__CwsDzzFM__"